module.exports = __webpack_public_path__ + "media/public/pingo2-7ea6dfe6.svg";